// ============================================================
// EXPLAINER TEMPLATE — this is the basic skeleton. Edit freely.
//
// HOW TO REPURPOSE
//   1. NODES  — rename actors, change icons/positions.
//   2. WIRES  — connect the actors that talk to each other.
//   3. SCENES — tell your story scene by scene:
//        title / body        caption text (or title card)
//        duration            autoplay time in ms
//        isTitleCard: true   full-screen text card
//        showNodes: [ids]    nodes that appear in this scene
//        showWires: true     draw all wires from this scene on
//        pulses: {id: color} glow a node (blue|amber|red|green)
//        flows: [{wire, color, reverse}] animated dot on a wire
//        panel: {title, rows:[{label, status: PASS|FAIL|INFO}]}
//   4. The /explainer page and the Remotion MP4 render both
//      read this file. Re-render with `yarn render` in /app/remotion.
//
// The full KATLAS video script is kept for reference in
// explainerScript.katlas.js — copy scenes back from it any time.
// ============================================================

export const STAGE = { width: 1200, height: 700 };

export const COLORS = {
  bg: "#081831",
  grid: "#12294a",
  wire: "#2b4a76",
  nodeFill: "#0e2445",
  nodeStroke: "#3e6db5",
  text: "#dbe7f7",
  subtext: "#7d9cc4",
  amber: "#f5a623",
  red: "#ef4444",
  green: "#2ecc71",
  blue: "#4da3ff",
};

// Icons available: landmark, sliders, file, book, hexagon
export const NODES = [
  {
    id: "a",
    label: "Actor A",
    sublabel: "initiator",
    icon: "landmark",
    x: 165,
    y: 270,
  },
  {
    id: "hub",
    label: "Hub",
    sublabel: "shared state",
    icon: "sliders",
    x: 600,
    y: 250,
  },
  {
    id: "b",
    label: "Actor B",
    sublabel: "evidence owner",
    icon: "file",
    x: 380,
    y: 470,
  },
  {
    id: "c",
    label: "Actor C",
    sublabel: "record keeper",
    icon: "book",
    x: 830,
    y: 460,
  },
  {
    id: "end",
    label: "Endpoint",
    sublabel: "executor",
    icon: "hexagon",
    x: 1040,
    y: 250,
  },
];

export const WIRES = [
  { id: "a-hub", from: "a", to: "hub" },
  { id: "hub-end", from: "hub", to: "end" },
  { id: "hub-c", from: "hub", to: "c" },
  { id: "b-hub", from: "b", to: "hub" },
  { id: "b-c", from: "b", to: "c" },
];

export const SCENES = [
  {
    id: "title",
    duration: 5000,
    title: "Your Title Here",
    body: "A one-line subtitle describing the flow.",
    isTitleCard: true,
  },
  {
    id: "actors",
    duration: 8000,
    title: "The actors",
    body: "Introduce your actors here. Add one scene per actor with showNodes to reveal them one at a time.",
    showNodes: ["a", "hub", "b", "c", "end"],
    pulses: { a: "blue", hub: "blue", b: "blue", c: "blue", end: "blue" },
  },
  {
    id: "connections",
    duration: 7000,
    title: "Connections",
    body: "Describe what travels along the wires between your actors.",
    showWires: true,
  },
  {
    id: "state-change",
    duration: 9000,
    title: "A state change",
    body: "Show something happening: an amber pulse, an animated flow along a wire, and an optional side panel with checks.",
    pulses: { a: "amber", hub: "amber" },
    flows: [{ wire: "a-hub", color: "amber" }],
    panel: {
      title: "Example panel",
      rows: [
        { label: "First check", status: "PASS" },
        { label: "Second check", status: "FAIL" },
        { label: "A plain note", status: "INFO" },
      ],
    },
  },
  {
    id: "close",
    duration: 6000,
    title: "Closing message",
    body: "End with the takeaway you want viewers to remember.",
    isTitleCard: true,
  },
];
